import {
  FETCH_AGENT_TRAINING_REQUEST,
  FETCH_AGENT_TRAINING_SUCCESS,
  FETCH_AGENT_TRAINING_FAILURE,

  CREATE_AGENT_TRAINING_REQUEST,
  CREATE_AGENT_TRAINING_SUCCESS,
  CREATE_AGENT_TRAINING_FAILURE,

  UPDATE_AGENT_TRAINING_REQUEST,
  UPDATE_AGENT_TRAINING_SUCCESS,
  UPDATE_AGENT_TRAINING_FAILURE,

  DELETE_AGENT_TRAINING_REQUEST,
  DELETE_AGENT_TRAINING_SUCCESS,
  DELETE_AGENT_TRAINING_FAILURE,
} from "../actions/types";


const initialState = {

  training: {
    data: [],
  },

  loading: false,

  error: null,

  message: "",

  page: 1,

  pages: 1,

  total: 0,
};


const agentTrainingReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {


    case FETCH_AGENT_TRAINING_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case FETCH_AGENT_TRAINING_SUCCESS: {

      const {
        data,
        page,
        pages,
        total,
      } = action.payload || {};

      return {

        ...state,

        loading: false,

        training: {
          data: data || [],
        },

        page:
          page || 1,

        pages:
          pages || 1,

        total:
          total || 0,

        message:
          "Agent Training loaded successfully",
      };
    }


    case FETCH_AGENT_TRAINING_FAILURE:

      return {

        ...state,

        loading: false,

        error:
          action.payload,

        training: {
          data: [],
        },
      };



    case CREATE_AGENT_TRAINING_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case CREATE_AGENT_TRAINING_SUCCESS:

      return {

        ...state,

        loading: false,

        training: {
          ...state.training,

          data: [
            ...(state.training?.data || []),
            action.payload,
          ],
        },

        total:
          state.total + 1,

        message:
          "Agent Training created successfully",
      };


    case CREATE_AGENT_TRAINING_FAILURE:

      return {

        ...state,

        loading: false,

        error:
          action.payload,
      };



    case UPDATE_AGENT_TRAINING_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case UPDATE_AGENT_TRAINING_SUCCESS: {

      const updatedTraining =
        action.payload;

      return {

        ...state,

        loading: false,

        training: {

          ...state.training,

          data:
            Array.isArray(
              state.training?.data
            )
              ? state.training.data.map(
                  (training) =>
                    training.training_id ===
                    updatedTraining.training_id
                      ? {
                          ...training,
                          ...updatedTraining,
                        }
                      : training
                )
              : [],
        },

        message:
          "Agent Training updated successfully",
      };
    }


    case UPDATE_AGENT_TRAINING_FAILURE:

      return {

        ...state,

        loading: false,

        error:
          action.payload,
      };


    case DELETE_AGENT_TRAINING_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case DELETE_AGENT_TRAINING_SUCCESS:

      return {

        ...state,

        loading: false,

        training: {

          ...state.training,

          data:
            Array.isArray(
              state.training?.data
            )
              ? state.training.data.filter(
                  (training) =>
                    training.training_id !==
                    action.payload
                )
              : [],
        },

        total:
          Math.max(
            0,
            state.total - 1
          ),

        message:
          "Agent Training deleted successfully",
      };


    case DELETE_AGENT_TRAINING_FAILURE:

      return {

        ...state,

        loading: false,

        error:
          action.payload,
      };


    default:
      return state;
  }
};


export default agentTrainingReducer;